import { RoleData, UserData, UserOrganizerData } from 'src/@types/user';
import { getNavConfig } from '../navbar/NavConfig';
import { NavConfig, NavItem } from 'src/@types/menu';
import { FeatureFlags } from 'src/@types/types';
import { disabledCompanyDataMenu } from 'src/common/utils/company-data';

export const getFilteredNavConfig = (params: {
  user: UserData | null;
  currentOrganizer: UserOrganizerData | null;
  currentRole: RoleData | null;
  featureFlags?: FeatureFlags;
  permissions: number[];
  disabledBoxOffice?: boolean;
}) => {
  const { user, currentOrganizer, currentRole, featureFlags, permissions, disabledBoxOffice } =
    params;

  const disabledCompanyData = disabledCompanyDataMenu({
    organizer: currentOrganizer,
    role: currentRole,
    user,
  });

  const filteredNavConfig = getNavConfig({
    featureFlags,
    disabledCompanyData,
    disabledBoxOffice,
  }).reduce((filteredNavConfig: NavConfig[], navConfig: NavConfig) => {
    const navItems = navConfig.items.reduce((navItems: NavItem[], navItem: NavItem) => {
      if (navItem.disabledFeature) {
        return navItems;
      }

      if (
        !navItem.children &&
        (!navItem.value || currentRole?.isOrganizer || permissions.includes(navItem.value))
      ) {
        navItems.push(navItem);
      }

      if (navItem.children) {
        const filteredChildren = navItem.children.filter(
          (child) =>
            !child.disabledFeature &&
            (!child.value || currentRole?.isOrganizer || permissions.includes(child.value))
        );

        !!filteredChildren.length && navItems.push({ ...navItem, children: filteredChildren });
      }

      return navItems;
    }, []);

    !!navItems.length && filteredNavConfig.push({ ...navConfig, items: navItems });

    return filteredNavConfig;
  }, []);

  return filteredNavConfig;
};
